import { render, staticRenderFns } from "./revenue-summary.vue?vue&type=template&id=3924e096&scoped=true&"
import script from "./revenue-summary.vue?vue&type=script&lang=js&"
export * from "./revenue-summary.vue?vue&type=script&lang=js&"
import style0 from "./revenue-summary.vue?vue&type=style&index=0&id=3924e096&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3924e096",
  null
  
)

export default component.exports